// extracted by mini-css-extract-plugin
export default {"backdrop":"Menu_backdrop__VoQ7u","main":"Menu_main__0iYfp","divider":"Menu_divider__MA51W"};